/** Tailles de police (px) — liste type Word. */
export const EDITOR_FONT_SIZE_PX = [
  '8px',
  '9px',
  '10px',
  '11px',
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '22px',
  '24px',
  '26px',
  '28px',
  '36px',
  '48px',
  '72px',
];

export const EDITOR_FONT_WHITELIST = [
  'sans',
  'serif',
  'monospace',
  'arial',
  'georgia',
  'times-new-roman',
  'courier-new',
  'verdana',
  'tahoma',
  'trebuchet-ms',
  'site-font',
];

export const MENU_FONT_OPTIONS = [
  { value: 'system', label: 'Système (sans-serif)' },
  { value: 'serif', label: 'Serif (Georgia…)' },
  { value: 'arial', label: 'Arial' },
  { value: 'georgia', label: 'Georgia' },
  { value: 'times-new-roman', label: 'Times New Roman' },
  { value: 'verdana', label: 'Verdana' },
  { value: 'tahoma', label: 'Tahoma' },
  { value: 'trebuchet-ms', label: 'Trebuchet MS' },
  { value: 'monospace', label: 'Monospace' },
  { value: 'site', label: 'Police du site' },
];

export function menuFontFamilyCss(key, siteTypography) {
  const k = key || 'system';
  if (k === 'site' && siteTypography?.fontFamily) {
    const name = String(siteTypography.fontFamily).replace(/"/g, '\\"');
    return `"${name}", system-ui, sans-serif`;
  }
  const stacks = {
    system: 'system-ui, -apple-system, Segoe UI, sans-serif',
    serif: 'Georgia, "Times New Roman", serif',
    arial: 'Arial, Helvetica, sans-serif',
    georgia: 'Georgia, serif',
    'times-new-roman': '"Times New Roman", Times, serif',
    verdana: 'Verdana, Geneva, sans-serif',
    tahoma: 'Tahoma, Geneva, sans-serif',
    'trebuchet-ms': '"Trebuchet MS", Helvetica, sans-serif',
    monospace: 'ui-monospace, "Courier New", monospace',
  };
  return stacks[k] || stacks.system;
}

export function clampMenuFontSize(px) {
  const n = Number(px);
  if (!Number.isFinite(n)) return 14;
  return Math.max(8, Math.min(96, Math.round(n)));
}

export function clampEditorFontSizePx(px) {
  const n = Number(px);
  if (!Number.isFinite(n)) return 16;
  return Math.max(6, Math.min(200, Math.round(n)));
}

export function editorFontSizeCss(px) {
  return `${clampEditorFontSizePx(px)}px`;
}
